var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.5 4a2.5 2.5 0 1 1 0 5h-2a.5.5 0 0 1 0-1h2a1.5 1.5 0 1 0 0-3h-2a.5.5 0 1 1 0-1zM0 6.5A2.5 2.5 0 0 1 2.5 4h2a.5.5 0 0 1 0 1h-2a1.5 1.5 0 0 0 0 3h2a.5.5 0 0 1 0 1h-2A2.5 2.5 0 0 1 0 6.5m2.5 0A.5.5 0 0 1 3 6h6a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5",
    clipRule: "evenodd"
  })));
});
const SvgLinksmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLinksmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05LjQ5OTkzIDRDMTAuODgwNyAzLjk5OTk0IDEyIDUuMTE5MjIgMTIgNi40OTk5NUMxMiA3Ljg4MDY0IDEwLjg4MDcgOC45OTk5MSA5LjUwMDA1IDguOTk5OTFINy41QzcuMjIzODYgOC45OTk5MSA3IDguNzc2MDUgNyA4LjQ5OTkxQzcgOC4yMjM3NiA3LjIyMzg2IDcuOTk5OTEgNy41IDcuOTk5OTFIOS41MDAwNUMxMC4zMjg0IDcuOTk5OTEgMTEgNy4zMjgzNiAxMSA2LjQ5OTk1QzExIDUuNjcxNTIgMTAuMzI4NCA0Ljk5OTk2IDkuNDk5OTggNUw3LjUwMDAyIDUuMDAwMDlDNy4yMjM4OCA1LjAwMDExIDcuMDAwMDEgNC43NzYyNiA3IDQuNTAwMTJDNi45OTk5OSA0LjIyMzk3IDcuMjIzODMgNC4wMDAxMSA3LjQ5OTk4IDQuMDAwMDlMOS40OTk5MyA0Wk0wIDYuNTAwMDlDMCA1LjExOTM4IDEuMTE5MjkgNC4wMDAwOSAyLjUgNC4wMDAwOUg0LjVDNC43NzYxNCA0LjAwMDA5IDUgNC4yMjM5NSA1IDQuNTAwMDlDNSA0Ljc3NjIzIDQuNzc2MTQgNS4wMDAwOSA0LjUgNS4wMDAwOUgyLjVDMS42NzE1NyA1LjAwMDA5IDEgNS42NzE2NyAxIDYuNTAwMDlDMSA3LjMyODUyIDEuNjcxNTcgOC4wMDAwOSAyLjUgOC4wMDAwOUg0LjVDNC43NzYxNCA4LjAwMDA5IDUgOC4yMjM5NSA1IDguNTAwMDlDNSA4Ljc3NjI0IDQuNzc2MTQgOS4wMDAwOSA0LjUgOS4wMDAwOUgyLjVDMS4xMTkyOSA5LjAwMDA5IDAgNy44ODA4IDAgNi41MDAwOVpNMi41IDYuNUMyLjUgNi4yMjM4NiAyLjcyMzg2IDYgMyA2SDlDOS4yNzYxNCA2IDkuNSA2LjIyMzg2IDkuNSA2LjVDOS41IDYuNzc2MTQgOS4yNzYxNCA3IDkgN0gzQzIuNzIzODYgNyAyLjUgNi43NzYxNCAyLjUgNi41WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";